var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "proxy" },
    [
      _c("sec-title", {
        attrs: { isShowHelp: false, title: _vm.$t("trade.proxy.title") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "btn_group" }, [
        _c(
          "div",
          {
            staticClass: "__trade-btn __pointer",
            on: {
              click: function($event) {
                return _vm._addProxy({ actionType: "new" })
              }
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("trade.proxy.new")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "__trade-btn __trade-btn__cancel __pointer",
            on: { click: _vm.gotoProxyInfo }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("trade.proxy.info")) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("trade.proxy.active.title")))
      ]),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "proxy-table",
          attrs: {
            headList: _vm.relationHeadList,
            contentList: _vm.relationList
          }
        },
        _vm._l(_vm.relationList, function(item, i) {
          return _c(
            "span",
            {
              key: i,
              attrs: { slot: i + "operationBefore" },
              slot: i + "operationBefore"
            },
            [
              _c(
                "span",
                {
                  staticClass: "click-able",
                  on: {
                    click: function($event) {
                      return _vm._addProxy(item, "add")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("trade.proxy.active.operate.0")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "click-able",
                  on: {
                    click: function($event) {
                      return _vm._addProxy(item, "delete")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("trade.proxy.active.operate.1")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "click-able",
                  on: {
                    click: function($event) {
                      return _vm._addProxy(item, "deleteAll")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("trade.proxy.active.operate.2")) +
                      "\n            "
                  )
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("trade.proxy.passive.title")))
      ]),
      _vm._v(" "),
      _c("wallet-table", {
        staticClass: "proxy-table",
        attrs: { headList: _vm.grantorHeadList, contentList: _vm.grantorList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }